<template>
    <div>
        <main class="pb-12 space-y-12">
            <InstagramCarousel/>

            <section
                class="relative bg-cover dp-contentblock block-textimage is-green dp-fsimg py-largest"
                style="background-image: url(/images/backgrounds/App_BG_15.jpg);"
            >
                <div class="absolute top-0 left-0 w-full z-10 pointer-events-none">
                    <BrandWave
                        :height="200"
                        flip
                        variant="trio"
                    />
                </div>
                <div class="brand-overlay is-duo is-reversed"/>
                <article
                    class="container relative z-10 dp-article"
                    style="position:relative;"
                >
                    <div class="grid lg:grid-cols-5 gap-32 py-40">
                        <div class="lg:col-span-2">
                            <NuxtPicture
                                alt="Mit der 3D-Planer App von Sauerland Spielgeräte, Spielgeräte live erleben!"
                                class="js-fade-in is-added is-visible"
                                src="App_Content.png"
                                :img-attrs="{ class: 'rounded-lg mx-auto w-2/3 sm:w-full' }"
                            />
                        </div>
                        <div class="lg:col-span-3">
                            <div class="article-text js-fade-in is-added is-visible">
                                <h2 class="text-white!">
                                    Mit der 3D-Planer App von Sauerland Spielgeräte, Spielgeräte live
                                    erleben!
                                </h2>
                                <p class="article-teaser text-white!">
                                    Egal ob für einen öffentlichen Bereich, einen Kindergarten
                                    oder eine Schule - einen Spielplatz zu planen ist nicht ganz so leicht, wie sich das
                                    alle Beteiligten vorstellen. Erst recht nicht, wenn es sich dabei um die Vorstellung
                                    des fertigen Spielgerätes auf der geplanten Fläche handelt.
                                </p>
                                <p class="text-white!">
                                    Dazu haben wir, bei Sauerland Spielgeräte, die optimale Lösung für Sie geschaffen:
                                    Die 3D-Planer App, mit der Sie kinderleicht jede leere Fläche zum Leben erwecken
                                    können! Tauchen Sie selbst in die Welt der Augmented Reality und lassen Sie noch
                                    heute Ihren bereits konfigurierten Spielplatz oder alle Produkte aus unserem
                                    Produktkatalog vor Ihren Augen erscheinen.<br>
                                    <br>
                                </p>
                                <p class="flex gap-4">
                                    <a
                                        href="https://play.google.com/store/apps/details?id=com.Convario.SauerlandAR&amp;gl=DE"
                                        target="_blank"
                                        @click="gaEventGooglePlay()"
                                    >
                                        <NuxtPicture
                                            alt=""
                                            height="52"
                                            src="google_play.png"
                                            width="177"
                                        />
                                    </a>
                                    <a
                                        href="https://apps.apple.com/de/app/3d-planer/id1593852740"
                                        target="_blank"
                                        @click="gaEventAppStore()"
                                    >
                                        <NuxtPicture
                                            alt=""
                                            height="53"
                                            src="apple-button.png"
                                            width="157"
                                        />
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </article>
                <div class="absolute bottom-0 left-0 w-full z-10 pointer-events-none">
                    <BrandWave
                        :height="200"
                        variant="trio"
                    />
                </div>
            </section>

            <section class="relative">
                <article class="container dp-article">
                    <div class="grid lg:grid-cols-5 gap-16 py-16">
                        <div class="lg:col-span-2">
                            <img
                                alt="Ihr persönlicher Ansprechpartner"
                                class="js-fade-in is-added is-visible"
                                src="/images/ansprechpartner.svg"
                            >
                        </div>
                        <div class="lg:col-span-3">
                            <div class="article-text js-fade-in is-added is-visible">
                                <h2 class=" title">
                                    Ihr persönlicher Ansprechpartner
                                </h2>
                                <p class="article-teaser">
                                    Service ist uns wichtig, denn wir denken und handeln kundenpartnerschaftlich.
                                </p>
                                <p>
                                    Sie haben bei uns immer einen zentralen Ansprechpartner, der Sie von der Planung
                                    über
                                    die Fertigung und Montage bis hin zur sicherheitstechnischen Überprüfung Ihrer
                                    Spielgräte begleitet. Ihr persönlicher Fachberater ist mindestens geprüfter
                                    Sachkundiger für Spielplätze oder qualifizierter Spielplatzprüfer nach DIN 79161 und
                                    berät Sie auch gerne zum Thema Sicherheit.
                                </p>
                                <p>
                                    Wir haben diese Zertifizierung als erstes Unternehmen in Deutschland für alle
                                    Außendienstmitarbeiter, Techniker und Konstrukteure durchgeführt.
                                </p>
                                <UButton
                                    color="secondary"
                                    label="Mehr erfahren"
                                    size="xl"
                                    to="/Service/Kontakt/"
                                    variant="outline"
                                />
                            </div>
                        </div>
                    </div>
                </article>
            </section>

            <HighlightsSection/>

            <SectionsSectionIntro
                :images="sectionIntro.images"
                :teaser="sectionIntro.teaser"
                :text="sectionIntro.text"
                :title="sectionIntro.title"
            />

            <section>
                <article class="container dp-article">
                    <div class="article-text js-fade-in columns-1 lg:columns-2 space-y-4 is-added is-visible">
                        <h2 class="title">
                            Eine neue Dimension der digitalen Spielplatzgestaltung
                        </h2>
                        <p class="article-teaser">
                            Wenn aus einer ersten Idee eine Vision entsteht und aus einer Vision ein einzigartiges
                            Erlebnis bei der Planung Ihres Spielplatzes, dann dürfen Sie sich auf den neuen und
                            bahnbrechenden „Spielplatz-Konfigurator“ von Sauerland Spielgeräte freuen.
                        </p>
                        <p>
                            Sauerland Spielgeräte zählt nicht zuletzt wegen der vielen innovativen und durchdachten
                            Produkte, seit vielen Jahren zu den führenden Herstellern von Spielgeräten. Im Fokus steht
                            zusätzlich auch der Kundenservice, die Beratung und das sich Kunden einfach wohlfühlen.
                        </p>
                        <p class="pt-8">
                            <NuxtPicture
                                alt=""
                                height="360"
                                src="mockup_110520.png"
                                width="608"
                            />
                        </p>
                        <p>
                            „Wir haben uns überlegt, wie wir den Kundenservice und die Beratung noch bequemer und
                            einfacher gestalten können. Das Ergebnis ist unser neuer „Spielplatz-Konfigurator“, auf den
                            wir richtig stolz sind“, argumentiert Jürgen Saemann,&nbsp;zuständiger Projektleiter
                            bei Sauerland Spielgeräte.&nbsp;Gerade
                            während der verschiedenen und sich verändernden Einschränkungen während der Corona-Zeit,
                            bieten wir Ihnen die Möglichkeit, egal von welchem PC oder Laptop, live an Ihrer
                            Spielplatzplanung teil zu nehmen. Sie können dadurch direkt Einfluss auf die Planung nehmen
                            und verschiedene Varianten durchspielen. Dazu benötigen Sie lediglich einen Internetzugang.
                            Dies funktioniert ohne jeglichen Softwaredownload. Dann lassen Sie es sich direkt durch
                            einen
                            Mitarbeiter von Sauerland
                            Spielgeräte demonstrieren!
                        </p>
                        <UButton
                            :block="!isSm"
                            :to="{name: 'playgroundConfigurator'}"
                            color="secondary"
                            label="Mehr zum Spielplatz Konfigurator"
                            size="xl"
                            variant="outline"
                        />
                        <p class="pt-8">
                            <NuxtLink :to="{name: 'playgroundConfigurator'}">
                                <NuxtPicture
                                    alt=""
                                    height="401"
                                    src="Bildschirmfoto-2020-11-26-um-10.16.png"
                                    width="711"
                                    :img-attrs="{ class: 'rounded-lg' }"
                                />
                            </NuxtLink>
                        </p>
                    </div>
                </article>
            </section>

            <section
                class="relative bg-cover bg-center dp-contentblock block-title py-largest dp-fsimg"
                style="background-image: url(/images/backgrounds/BQ4C0119-1.jpg);"
            >
                <div class="absolute top-0 left-0 w-full z-10 pointer-events-none">
                    <BrandWave
                        :amplitude="200"
                        :frequency="1.5"
                        :height="300"
                        flip
                        flip-neutral
                        variant="neutral"
                    />
                </div>
                <span class="brand-overlay is-duo is-reversed noprint"/>
                <div class="relative z-10 py-48 dp-pagebounds">
                    <h2 class=" my-none py-large py-l-largest text-center text-white! js-fade-in is-added is-visible">
                        Unsere Philosophie
                    </h2>
                </div>
                <div class="absolute bottom-0 left-0 w-full z-10 pointer-events-none">
                    <BrandWave
                        :amplitude="200"
                        :frequency="1"
                        :height="400"
                        variant="neutral"
                    />
                </div>
            </section>

            <section class="dp-contentblock block-textimage image-fullsize">
                <article class="dp-article">
                    <div class="px-4 mx-auto lg:px-0 lg:mx-0">
                        <div class="grid lg:grid-cols-2">
                            <div class="lg:pl-80 lg:pr-16 py-16 space-y-8 order-2 lg:order-1">
                                <div>
                                    <h3>Pädagogik</h3>
                                    <p>
                                        Grenzen erfahren, Grenzen erweitern. Kinder spielerisch in einem sicheren Umfeld
                                        ihre
                                        Grenzen ausloten und erkennen lassen. Durch die Möglichkeit des gemeinsamen,
                                        altersübergreifenden Spielens können schon die Kleinen von den Großen lernen.
                                        Zitat
                                        DIN EN 1176 Bbl 1:2020-11: „Die Risiken des Lebens müssen von Kindern erlebbar,
                                        erlernbar und damit beherrschbar sein. Spiel mit Risiko ist somit
                                        lebensnotwendig.“
                                    </p>
                                </div>
                                <div>
                                    <h3>Inklusion</h3>
                                    <p>
                                        Im Rahmen der Inklusion auf deutschen Spielplätzen achten wir darauf, dass
                                        Menschen
                                        mit besonderen Fähigkeiten neben der Barrierefreiheit weitere Anreize zur
                                        Sinnes-
                                        und Bewegungsförderung erhalten, die individuell auf die Nutzer zugeschnitten
                                        sind.Gerne beraten und unterstützen wir Sie bei der Planung und Umsetzung Ihres
                                        Projektes zum gemeinsamen Spiel.
                                    </p>
                                </div>
                            </div>
                            <div
                                class="order-1 min-h-88 lg:order-2 bg-cover rounded-tl-[64px] drop-shadow-lg"
                                style="background-image: url(/images/backgrounds/BQ4C1535-1.jpg);"
                            />
                        </div>
                    </div>
                </article>
                <article class="dp-article">
                    <div class="px-4 mx-auto lg:px-0 lg:mx-0">
                        <div class="grid lg:grid-cols-2">
                            <div
                                class="min-h-88 bg-cover rounded-br-[64px] drop-shadow-lg"
                                style="background-image: url(/images/backgrounds/BQ4C2038-1.jpg);"
                            />
                            <div class="lg:pl-16 lg:pr-80 py-16 space-y-8 article-text js-fade-in is-added is-visible">
                                <div>
                                    <h3>Motorik</h3>
                                    <p>
                                        Frei- und Bewegungsräume, Wiesen zum Laufen und Bäume zum Klettern werden im
                                        Zuge
                                        der Urbanisierung seltener. Gerade hier ist es wichtig, unseren Kindern Bewegung
                                        zu
                                        ermöglichen und die Entwicklung der Motorik zu fördern. Spielplätze bieten
                                        hierzu
                                        vielfältige Möglichkeiten.
                                    </p>
                                </div>
                                <div>
                                    <h3>Spielwert</h3>
                                    <p>
                                        Kinder benötigen individuelle Anreize und entwickeln sich unterschiedlich.
                                        Deshalb
                                        bieten unsere Spielgeräte und Module unterschiedliche Grade der An- und
                                        Herausforderungen, welche auf den Alters- und Entwicklungsstand der jeweiligen
                                        Nutzer abgestimmt werden.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </section>

            <section>
                <Carousel/>
            </section>
        </main>
    </div>
</template>

<script lang="ts" setup>
import {useBreakpoints, breakpointsTailwind} from '@vueuse/core';
import HighlightsSection from '~/components/HighlightsSection.vue';

// ...existing code...

const breakpoints = useBreakpoints(breakpointsTailwind, {
    ssrWidth: 397,
});
const isSm = breakpoints.greaterOrEqual('sm');

definePageMeta({
    path: '/',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Eine Welt',
    subTitle: 'voller Ideen',
};

const {gtag} = useGtag();

function gaEventVideo(name) {
    gtag('event', 'select_content', {
        content_type: 'Video',
        content_id: name,
    });
    gtag('event', 'conversion', {send_to: 'AW-428666490/u1zNCLLvuOYYEPrcs8wB'});
}

function gaEventGooglePlay() {
    gtag('event', 'select_content', {
        content_type: 'Appstore',
        content_id: 'Android',
    });
    gtag('event', 'conversion', {send_to: 'AW-428666490/oQYtCKmbv-YYEPrcs8wB'});
}

function gaEventAppStore() {
    gtag('event', 'select_content', {
        content_type: 'Appstore',
        content_id: 'iOS',
    });
    gtag('event', 'conversion', {send_to: 'AW-428666490/-LSCCNKIv-YYEPrcs8wB'});
}

function gaEventMail(email) {
    gtag('event', 'conversion', {send_to: 'AW-428666490/YM8DCNvT46oDEPrcs8wB'});
    gtag('event', 'select_content', {
        content_type: 'Website mailto',
        content_id: email,
    });
}

function gaEventPdf(pdfUrl) {
    gtag('event', 'conversion', {send_to: 'AW-428666490/7sivCObz46oDEPrcs8wB'});
    gtag('event', 'select_content', {
        content_type: 'Website pdf',
        content_id: pdfUrl,
    });
}

function gaEventCloseContactPerson() {
    gtag('event', 'select_content', {
        content_type: 'Website Interaktion',
        content_id: 'Ansprechpartnersuche schließen',
    });
}

function gaEventOpenContactPerson() {
    gtag('event', 'select_content', {
        content_type: 'Website Interaktion',
        content_id: 'Ansprechpartnersuche öffnen',
    });
}

const sectionIntro = {
    images: ['1184944-1800_2.jpg', 'BQ4C0119-1.jpg', 'Bild-%2888%29_02.jpg'],
    title: 'Sauerland Spielgeräte',
    teaser: 'Seit 1987 kümmern wir uns mit nahezu 100 Mitarbeitern rund um das Thema Spielplatzgeräte. Als mittelständisches Familienunternehmen fertigen wir an unserem Standort in Niederntudorf fast Alles aus eigener Hand.',
    text: '<p>Neben unserer Holzproduktion, die vorwiegend heimische Douglasie verarbeitet, produzieren wir auch Spielgeräte aus Stahl, Aluminium und Melamin in unserem Werk. Alle Spielgeräte entsprechen natürlich den Vorgaben der DIN EN 1176 sowie bei Spielgeräten für Kindergärten und Schulen den entsprechenden DGUV Sicherheitsrichtlinien.</p>'
        + '<p>Zu unserem Service gehört die komplette Abwicklung, von der Idee bis zum fertigen Spielplatz!</p>',
};
</script>

<style scoped>
</style>
